/**
 * 마크업에 비워 둔 자리([data-richtext])에 공용 설명글 편집기(richText.js)를 붙인다.
 *
 * 실제 화면(매장 설명글 · 소식 · 케어)은 각 모듈이 createRichText 를 직접 부르고,
 * 여기는 /ui/ 처럼 마크업만으로 편집기를 보여 줄 때 쓴다. data-placeholder 가 안내 문구다.
 */

import { createRichText } from './richText';

const InitRichText = () => {
  document.querySelectorAll('[data-richtext]').forEach((holder) => {
    const editor = createRichText({
      html: holder.innerHTML.trim(),
      placeholder: holder.dataset.placeholder || '',
    });

    holder.replaceChildren(editor.element);
  });
};

export default InitRichText;
